<template>
    <div class="loading">
        <v-progress-circular
            indeterminate
            color="white"
            :size="70"
        ></v-progress-circular>
        <br><br><br>
        {{$t('loading.index.loading_text')}}
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.loading{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Loading/index.vue